// extracted by mini-css-extract-plugin
module.exports = {"ContactData":"ContactData_ContactData__1UAxl","FormData":"ContactData_FormData__1qtMX","SubmitButton":"ContactData_SubmitButton__24Ckl"};